// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Admin User Management Styles — Dark Data-Dashboard Theme ===== */

/* Stats Grid */
.admin-user__stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.admin-user__stat-card {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-lg);
  padding: 20px;
  transition: all 0.2s;
}

.admin-user__stat-card:hover {
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.35);
  transform: translateY(-2px);
}

.admin-user__stat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.admin-user__stat-icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
}

.admin-user__stat-icon--total {
  background: rgba(167, 139, 250, 0.1);
  color: #a78bfa;
}

.admin-user__stat-icon--member {
  background: var(--admin-info-bg);
  color: var(--admin-info);
}

.admin-user__stat-icon--partner {
  background: rgba(167, 139, 250, 0.15);
  color: #c4b5fd;
}

.admin-user__stat-icon--manager {
  background: var(--admin-warning-bg);
  color: var(--admin-warning);
}

.admin-user__stat-icon--admin {
  background: var(--admin-warning-bg);
  color: var(--admin-warning);
}

.admin-user__stat-icon--org {
  background: var(--admin-success-bg);
  color: var(--admin-success);
}

.admin-user__stat-label {
  font-size: 12px;
  color: var(--admin-text-muted);
  margin-bottom: 8px;
}

.admin-user__stat-value {
  font-size: 28px;
  font-weight: 700;
  color: var(--admin-text-bright);
}

/* Tabs */
.admin-user__tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.admin-user__tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  font-size: 13px;
  font-weight: 500;
  color: var(--admin-text-secondary);
  background: var(--admin-surface);
  cursor: pointer;
  transition: all 0.2s;
}

.admin-user__tab:hover {
  background: var(--admin-surface-hover);
  border-color: var(--admin-text-dim);
  color: var(--admin-text-primary);
}

.admin-user__tab--active {
  background: var(--admin-surface-hover);
  color: var(--admin-text-bright);
  border-color: var(--admin-text-dim);
}

.admin-user__tab-badge {
  background: var(--admin-surface-hover);
  color: var(--admin-text-secondary);
  padding: 2px 10px;
  border-radius: var(--radius-full);
  font-size: 12px;
  font-weight: 600;
  min-width: 24px;
  text-align: center;
}

.admin-user__tab--active .admin-user__tab-badge {
  background: rgba(167, 139, 250, 0.15);
  color: #a78bfa;
}

/* Table Container */
.admin-user__table-container {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.admin-user__table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid var(--admin-border);
  background: var(--admin-surface);
  gap: 16px;
}

.admin-user__table-title {
  font-size: 15px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--admin-text-bright);
  white-space: nowrap;
}

.admin-user__table-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.admin-user__search-input {
  width: 260px;
  padding: 8px 14px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  font-size: 13px;
  background: var(--admin-bg);
  color: var(--admin-text-primary);
  transition: all 0.2s;
}

.admin-user__search-input:focus {
  outline: none;
  border-color: #a78bfa;
  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);
}

.admin-user__search-input::placeholder {
  color: var(--admin-text-muted);
}

/* 동의 목록 JSON 다운로드 버튼 */
.admin-user__download-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  background: var(--admin-surface);
  color: var(--admin-text-secondary);
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s;
}

.admin-user__download-btn:hover {
  border-color: var(--admin-accent);
  color: var(--admin-accent-hover);
  background: var(--admin-accent-bg);
}

.admin-user__download-btn .admin-icon {
  width: 15px;
  height: 15px;
}

/* Bulk Actions Bar */
.admin-user__bulk-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 24px;
  background: var(--admin-surface);
  border-bottom: 1px solid var(--admin-border);
  animation: bulkBarIn 0.2s ease;
}

@keyframes bulkBarIn {
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
}

.admin-user__bulk-count {
  font-size: 13px;
  font-weight: 600;
  color: #a78bfa;
  white-space: nowrap;
}

.admin-user__bulk-select {
  padding: 6px 12px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  font-size: 12px;
  background: var(--admin-bg);
  color: var(--admin-text-primary);
  cursor: pointer;
}

.admin-user__bulk-select:focus {
  outline: none;
  border-color: #a78bfa;
}

.admin-user__bulk-btn {
  padding: 6px 14px;
  border: none;
  border-radius: var(--radius-md);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  background: #a78bfa;
  color: var(--admin-bg);
}

.admin-user__bulk-btn:hover {
  background: #8b5cf6;
}

.admin-user__bulk-btn--danger {
  background: #ef4444;
  color: #fff;
}

.admin-user__bulk-btn--danger:hover {
  background: #dc2626;
}

.admin-user__bulk-cancel {
  padding: 6px 14px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  background: var(--admin-bg);
  color: var(--admin-text-secondary);
  transition: all 0.2s;
}

.admin-user__bulk-cancel:hover {
  background: var(--admin-surface-hover);
  color: var(--admin-text-primary);
}

/* Table */
.admin-user__table-wrap {
  overflow-x: auto;
}

.admin-user__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.admin-user__table th {
  text-align: left;
  padding: 10px 16px;
  font-size: 11px;
  font-weight: 600;
  color: var(--admin-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  background: var(--admin-surface);
  border-bottom: 1px solid var(--admin-border);
  white-space: nowrap;
}

.admin-user__table td {
  padding: 12px 16px;
  border-bottom: 1px solid var(--admin-border-light);
  vertical-align: middle;
  color: var(--admin-text-primary);
}

.admin-user__table tbody tr {
  transition: background 0.15s;
}

.admin-user__table tbody tr:hover {
  background: var(--admin-surface-hover);
}

.admin-user__table tbody tr:last-child td {
  border-bottom: none;
}

.admin-user__table tbody tr.admin-user__row--selected {
  background: rgba(167, 139, 250, 0.08);
}

/* Checkbox */
.admin-user__checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #a78bfa;
}

/* User Cell */
.admin-user__cell-user {
  display: flex;
  align-items: center;
  gap: 12px;
}

.admin-user__avatar {
  width: 36px;
  height: 36px;
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  color: white;
  flex-shrink: 0;
}

.admin-user__avatar--admin {
  background: linear-gradient(135deg, rgba(251, 146, 60, 0.2), rgba(251, 146, 60, 0.1));
  color: var(--admin-warning);
}

.admin-user__avatar--member {
  background: linear-gradient(135deg, rgba(34, 211, 238, 0.2), rgba(34, 211, 238, 0.1));
  color: var(--admin-info);
}

.admin-user__avatar--partner {
  background: linear-gradient(135deg, #a78bfa, #7c3aed);
  color: white;
}

.admin-user__avatar--manager {
  background: linear-gradient(135deg, rgba(251, 146, 60, 0.2), rgba(251, 146, 60, 0.1));
  color: var(--admin-warning);
}

.admin-user__avatar--organization {
  background: linear-gradient(135deg, rgba(74, 222, 128, 0.2), rgba(74, 222, 128, 0.1));
  color: var(--admin-success);
}

.admin-user__name {
  font-weight: 600;
  color: var(--admin-text-bright);
  font-size: 13px;
}

.admin-user__email {
  font-size: 12px;
  color: var(--admin-text-muted);
  margin-top: 2px;
}

/* Role Badge */
.admin-user__role-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: var(--radius-full);
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.admin-user__role-badge--admin {
  background: var(--admin-warning-bg);
  color: var(--admin-warning);
}

.admin-user__role-badge--member {
  background: var(--admin-info-bg);
  color: var(--admin-info);
}

.admin-user__role-badge--partner {
  background: rgba(167, 139, 250, 0.12);
  color: #a78bfa;
}

.admin-user__role-badge--manager {
  background: var(--admin-warning-bg);
  color: var(--admin-warning);
}

.admin-user__role-badge--organization {
  background: var(--admin-success-bg);
  color: var(--admin-success);
}

/* Status */
.admin-user__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
}

.admin-user__status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
}

.admin-user__status--active .admin-user__status-dot {
  background: var(--admin-success);
  box-shadow: 0 0 0 3px var(--admin-success-bg);
}

.admin-user__status--active {
  color: var(--admin-success);
}

.admin-user__status--inactive .admin-user__status-dot {
  background: var(--admin-text-dim);
}

.admin-user__status--inactive {
  color: var(--admin-text-muted);
}

/* 수신동의 뱃지 (테이블) */
.admin-user__consent {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.admin-user__consent-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 7px 2px 5px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
}

.admin-user__consent-badge svg {
  width: 11px;
  height: 11px;
  flex-shrink: 0;
}

.admin-user__consent-badge--on {
  background: var(--admin-success-bg);
  color: var(--admin-success);
}

.admin-user__consent-badge--off {
  background: var(--admin-surface-hover);
  color: var(--admin-text-muted);
}

.admin-user__consent-old {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px dashed var(--admin-border);
  background: transparent;
  color: var(--admin-text-muted);
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}

/* 수신동의 현황 (사이드 패널) */
.admin-user__panel-consent-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.admin-user__panel-consent-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.admin-user__panel-consent-label {
  font-size: 12px;
  color: var(--admin-text-secondary);
}

.admin-user__panel-consent-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
}

.admin-user__panel-consent-status--on {
  color: var(--admin-success);
}

.admin-user__panel-consent-status--off {
  color: var(--admin-text-muted);
}

.admin-user__panel-consent-at {
  font-size: 11px;
  font-weight: 400;
  color: var(--admin-text-muted);
}

.admin-user__panel-consent-empty {
  padding: 10px 12px;
  border-radius: var(--admin-radius-sm);
  background: var(--admin-surface-hover);
  color: var(--admin-text-muted);
  font-size: 12px;
  line-height: 1.5;
}

/* Action Buttons */
.admin-user__action-group {
  display: flex;
  gap: 6px;
}

.admin-user__action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--admin-text-secondary);
  cursor: pointer;
  transition: all 0.2s;
}

.admin-user__action-btn:hover {
  background: var(--admin-surface-hover);
  border-color: var(--admin-text-dim);
  color: var(--admin-text-primary);
}

.admin-user__action-btn--danger:hover {
  background: var(--admin-error-bg);
  border-color: var(--admin-error);
  color: var(--admin-error);
}

/* Modal */
.admin-user__modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
}

.admin-user__modal {
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-xl);
  width: 100%;
  max-width: 480px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  animation: modalIn 0.2s ease;
}

.admin-user__modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid var(--admin-border);
}

.admin-user__modal-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--admin-text-bright);
}

.admin-user__modal-close {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-md);
  background: var(--admin-bg);
  border: 1px solid var(--admin-border);
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--admin-text-secondary);
  transition: all 0.2s;
}

.admin-user__modal-close:hover {
  background: var(--admin-surface-hover);
  color: var(--admin-text-bright);
}

.admin-user__modal-body {
  padding: 24px;
}

.admin-user__modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid var(--admin-border);
  background: var(--admin-bg);
}

.admin-user__modal-user {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: var(--admin-bg);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  margin-bottom: 20px;
}

.admin-user__modal-user-info {
  flex: 1 1;
}

.admin-user__modal-user-name {
  font-weight: 600;
  font-size: 14px;
  color: var(--admin-text-bright);
}

.admin-user__modal-user-email {
  font-size: 12px;
  color: var(--admin-text-muted);
  margin-top: 2px;
}

.admin-user__form-group {
  margin-bottom: 20px;
}

.admin-user__form-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--admin-text-primary);
}

.admin-user__form-select {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  font-size: 14px;
  background: var(--admin-bg);
  color: var(--admin-text-primary);
  transition: all 0.2s;
  cursor: pointer;
}

.admin-user__form-select:focus {
  outline: none;
  border-color: #a78bfa;
  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);
}

.admin-user__role-change-preview {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(167, 139, 250, 0.08);
  border: 1px solid rgba(167, 139, 250, 0.2);
  border-radius: var(--radius-md);
  font-size: 13px;
  color: var(--admin-text-primary);
}

.admin-user__role-arrow {
  color: var(--admin-text-muted);
  font-size: 16px;
}

/* Empty State */
.admin-user__empty-state {
  text-align: center;
  padding: 60px 20px;
}

.admin-user__empty-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;
  color: var(--admin-text-dim);
  stroke-width: 1.5;
  stroke: currentColor;
  fill: none;
}

.admin-user__empty-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--admin-text-secondary);
  margin-bottom: 8px;
}

.admin-user__empty-desc {
  font-size: 13px;
  color: var(--admin-text-muted);
}

/* Pagination */
.admin-user__pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  border-top: 1px solid var(--admin-border);
  background: var(--admin-surface);
}

.admin-user__pagination-info {
  font-size: 12px;
  color: var(--admin-text-muted);
}

.admin-user__pagination-buttons {
  display: flex;
  gap: 4px;
}

.admin-user__pagination-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--admin-text-secondary);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.admin-user__pagination-btn:hover {
  background: var(--admin-surface-hover);
  border-color: var(--admin-text-dim);
  color: var(--admin-text-primary);
}

.admin-user__pagination-btn--active {
  background: var(--admin-accent);
  border-color: var(--admin-accent);
  color: #fff;
}

.admin-user__pagination-btn--active:hover {
  background: var(--admin-accent-hover);
  border-color: var(--admin-accent-hover);
  color: #fff;
}

.admin-user__pagination-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.admin-user__pagination-ellipsis {
  display: inline-flex;
  align-items: flex-end;
  justify-content: center;
  min-width: 24px;
  height: 32px;
  padding-bottom: 6px;
  color: var(--admin-text-muted);
  font-size: 12px;
  -webkit-user-select: none;
          user-select: none;
}

/* Date text */
.admin-user__date {
  font-size: 12px;
  color: var(--admin-text-secondary);
}

/* Enrollment stat icon */
.admin-user__stat-icon--enrollment {
  background: var(--admin-success-bg);
  color: var(--admin-success);
}

/* Avatar — image and initial variants */
.admin-users__avatar {
  width: 30px;
  height: 30px;
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  color: white;
  flex-shrink: 0;
  object-fit: cover;
}

.admin-users__avatar--initial {
  /* color is provided by admin-user__avatar--{role} modifier */
  -webkit-user-select: none;
          user-select: none;
}

/* Department cell */
.admin-user__department {
  font-size: 12px;
  color: var(--admin-text-secondary);
}

/* Activity (enrollment / session) cell */
.admin-user__activity {
  font-size: 12px;
  color: var(--admin-text-secondary);
  white-space: nowrap;
}

/* ===== Layout: Table + Side Panel ===== */
.admin-user__layout {
  display: flex;
  gap: 0;
  transition: all 0.3s ease;
}

.admin-user__layout .admin-user__table-container {
  flex: 1 1;
  min-width: 0;
  transition: all 0.3s ease;
}

/* ===== Token Number in Table ===== */
.admin-user__token-number {
  font-weight: 600;
  font-size: 13px;
  font-variant-numeric: tabular-nums;
}

.admin-user__token-number--normal {
  color: var(--admin-success);
}

.admin-user__token-number--warning {
  color: var(--admin-warning);
}

.admin-user__token-number--danger {
  color: var(--admin-error);
}

/* ===== Usage Bar in Table ===== */
.admin-user__usage {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 100px;
}

.admin-user__usage-bar {
  flex: 1 1;
  height: 6px;
  background: var(--admin-bg);
  border-radius: 3px;
  overflow: hidden;
}

.admin-user__usage-bar--lg {
  height: 8px;
}

.admin-user__usage-bar-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.6s ease;
}

.admin-user__usage-bar-fill--normal {
  background: var(--admin-success);
}

.admin-user__usage-bar-fill--warning {
  background: var(--admin-warning);
}

.admin-user__usage-bar-fill--danger {
  background: var(--admin-error);
}

.admin-user__usage-pct {
  font-size: 12px;
  font-weight: 600;
  min-width: 36px;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.admin-user__usage-pct--normal {
  color: var(--admin-success);
}

.admin-user__usage-pct--warning {
  color: var(--admin-warning);
}

.admin-user__usage-pct--danger {
  color: var(--admin-error);
}

/* Row active state when panel is open */
.admin-user__row--panel-active {
  background: rgba(167, 139, 250, 0.12) !important;
  border-left: 3px solid #a78bfa;
}

/* ===== Side Panel ===== */
.admin-user__panel {
  width: 400px;
  min-width: 400px;
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-lg);
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 180px);
  overflow: hidden;
  animation: panelSlideIn 0.3s ease;
  margin-left: 16px;
}

@keyframes panelSlideIn {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.admin-user__panel-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid var(--admin-border);
  gap: 12px;
}

.admin-user__panel-user {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  min-width: 0;
}

.admin-user__panel-avatar {
  width: 48px;
  height: 48px;
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
  color: white;
  flex-shrink: 0;
  object-fit: cover;
}

.admin-user__panel-avatar--initial {
  -webkit-user-select: none;
          user-select: none;
}

.admin-user__panel-user-info {
  flex: 1 1;
  min-width: 0;
}

.admin-user__panel-user-name {
  font-weight: 600;
  font-size: 15px;
  color: var(--admin-text-bright);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.admin-user__panel-user-email {
  font-size: 12px;
  color: var(--admin-text-muted);
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.admin-user__panel-close {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-md);
  background: var(--admin-bg);
  border: 1px solid var(--admin-border);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--admin-text-secondary);
  transition: all 0.2s;
  flex-shrink: 0;
}

.admin-user__panel-close:hover {
  background: var(--admin-surface-hover);
  color: var(--admin-text-bright);
}

.admin-user__panel-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 0;
}

/* Panel Sections */
.admin-user__panel-section {
  padding: 20px;
  border-bottom: 1px solid var(--admin-border);
}

.admin-user__panel-section:last-child {
  border-bottom: none;
}

.admin-user__panel-section-title {
  font-size: 12px;
  font-weight: 600;
  color: var(--admin-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 12px 0;
}

/* Info Grid */
.admin-user__panel-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 16px;
}

.admin-user__panel-info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.admin-user__panel-info-label {
  font-size: 11px;
  color: var(--admin-text-muted);
  font-weight: 500;
}

.admin-user__panel-info-value {
  font-size: 13px;
  color: var(--admin-text-primary);
  font-weight: 500;
}

/* Panel Actions */
.admin-user__panel-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

/* Token Grid in Panel */
.admin-user__panel-token-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
  margin-bottom: 12px;
}

.admin-user__panel-token-item {
  padding: 10px;
  background: var(--admin-bg);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  text-align: center;
}

.admin-user__panel-token-label {
  display: block;
  font-size: 10px;
  font-weight: 600;
  color: var(--admin-text-muted);
  margin-bottom: 4px;
}

.admin-user__panel-token-value {
  font-size: 14px;
  font-weight: 700;
  color: var(--admin-text-bright);
  font-variant-numeric: tabular-nums;
}

.admin-user__panel-token-empty {
  text-align: center;
  padding: 20px;
  font-size: 13px;
  color: var(--admin-text-muted);
}

.admin-user__panel-usage {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

/* History in Panel */
.admin-user__panel-history {
  max-height: 300px;
  overflow-y: auto;
}

.admin-user__panel-history-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.admin-user__panel-history-table th {
  text-align: left;
  font-size: 10px;
  font-weight: 600;
  color: var(--admin-text-muted);
  text-transform: uppercase;
  padding: 6px 8px;
  border-bottom: 1px solid var(--admin-border);
}

.admin-user__panel-history-table td {
  padding: 8px;
  border-bottom: 1px solid var(--admin-border-light);
  vertical-align: middle;
  color: var(--admin-text-primary);
}

.admin-user__panel-history-table tr:last-child td {
  border-bottom: none;
}

.admin-user__panel-history-date {
  color: var(--admin-text-muted);
  font-size: 11px;
  white-space: nowrap;
}

.admin-user__panel-history-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px 0 0;
  margin-top: 8px;
  border-top: 1px solid var(--admin-border);
}

.admin-user__panel-history-page {
  font-size: 12px;
  color: var(--admin-text-secondary);
}

.admin-user__panel-history-empty {
  text-align: center;
  padding: 24px;
  font-size: 13px;
  color: var(--admin-text-muted);
}

/* Transaction Badge */
.admin-user__tx-badge {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
}

.admin-user__tx-badge--usage {
  background: var(--admin-info-bg);
  color: var(--admin-info);
}

.admin-user__tx-badge--admin_grant {
  background: var(--admin-success-bg);
  color: var(--admin-success);
}

.admin-user__tx-badge--admin_deduct {
  background: var(--admin-warning-bg);
  color: var(--admin-warning);
}

.admin-user__tx-badge--purchase {
  background: rgba(167, 139, 250, 0.12);
  color: #a78bfa;
}

.admin-user__tx-badge--refund {
  background: var(--admin-error-bg);
  color: var(--admin-error);
}

.admin-user__tx-positive {
  color: var(--admin-success);
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.admin-user__tx-negative {
  color: var(--admin-error);
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.admin-user__tx-balance {
  font-weight: 500;
  color: var(--admin-text-secondary);
  font-variant-numeric: tabular-nums;
}

/* Grant Modal — Balance Info */
.admin-user__grant-balance {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 20px;
}

.admin-user__grant-balance-item {
  padding: 12px 16px;
  background: var(--admin-bg);
  border-radius: var(--radius-md);
  border: 1px solid var(--admin-border);
}

.admin-user__grant-balance-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: var(--admin-text-muted);
  margin-bottom: 4px;
}

.admin-user__grant-balance-value {
  font-size: 18px;
  font-weight: 700;
  color: var(--admin-text-bright);
  font-variant-numeric: tabular-nums;
}

/* Form Input (for grant modal) */
.admin-user__form-input {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  font-size: 14px;
  background: var(--admin-bg);
  color: var(--admin-text-bright);
  transition: all 0.2s;
}

.admin-user__form-input:focus {
  outline: none;
  border-color: #a78bfa;
  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);
}

.admin-user__form-input::placeholder {
  color: var(--admin-text-muted);
}

/* Preset Buttons */
.admin-user__form-presets {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.admin-user__preset-btn {
  padding: 4px 12px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-full);
  font-size: 12px;
  font-weight: 500;
  color: var(--admin-text-secondary);
  background: var(--admin-bg);
  cursor: pointer;
  transition: all 0.2s;
}

.admin-user__preset-btn:hover {
  background: rgba(167, 139, 250, 0.1);
  border-color: #a78bfa;
  color: #a78bfa;
}

/* Small button variants */
.admin-btn--sm {
  padding: 6px 14px;
  font-size: 12px;
}

.admin-btn--danger {
  background: transparent;
  border: 1px solid var(--admin-error);
  color: var(--admin-error);
}

.admin-btn--danger:hover {
  background: var(--admin-error-bg);
}

/* ===== Stat icon variants for token stats ===== */
.admin-user__stat-icon--issued {
  background: rgba(167, 139, 250, 0.1);
  color: #a78bfa;
}

.admin-user__stat-icon--used {
  background: var(--admin-error-bg);
  color: var(--admin-error);
}

.admin-user__stat-icon--remaining {
  background: var(--admin-success-bg);
  color: var(--admin-success);
}

/* Roles inline stat value */
.admin-user__stat-value--roles {
  font-size: 13px;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 4px;
}

/* Token remaining in table */
.admin-user__token-remaining {
  font-weight: 600;
  font-size: 13px;
  font-variant-numeric: tabular-nums;
}

.admin-user__token-remaining--normal {
  color: var(--admin-success);
}

.admin-user__token-remaining--warning {
  color: var(--admin-warning);
}

.admin-user__token-remaining--danger {
  color: var(--admin-error);
}

/* Panel chevron button */
.admin-user__panel-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--admin-text-muted);
  cursor: pointer;
  transition: all 0.2s;
}

.admin-user__panel-btn:hover {
  background: var(--admin-surface-hover);
  color: var(--admin-text-primary);
}

.admin-user__panel-btn--active {
  background: rgba(167, 139, 250, 0.12);
  border-color: #a78bfa;
  color: #a78bfa;
}

/* Side panel — actual rendered element class */
.admin-user__side-panel {
  width: 400px;
  min-width: 400px;
  background: var(--admin-surface);
  border: 1px solid var(--admin-border);
  border-radius: var(--radius-lg);
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 180px);
  overflow: hidden;
  animation: panelSlideIn 0.3s ease;
  margin-left: 16px;
}

.admin-user__side-panel .admin-user__panel-body {
  flex: 1 1;
  overflow-y: auto;
}

/* Panel header user info block */
.admin-user__panel-user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  min-width: 0;
}

.admin-user__panel-user-meta {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

/* Panel avatar role color variants */
.admin-user__panel-avatar--admin {
  background: linear-gradient(135deg, rgba(251, 146, 60, 0.2), rgba(251, 146, 60, 0.1));
  color: var(--admin-warning);
}

.admin-user__panel-avatar--member {
  background: linear-gradient(135deg, rgba(34, 211, 238, 0.2), rgba(34, 211, 238, 0.1));
  color: var(--admin-info);
}

.admin-user__panel-avatar--partner {
  background: linear-gradient(135deg, #a78bfa, #7c3aed);
  color: white;
}

/* Panel token value color variants */
.admin-user__panel-token-value--used {
  color: var(--admin-error);
}

.admin-user__panel-token-value--balance {
  color: var(--admin-info);
}

.admin-user__panel-token-value--normal {
  color: var(--admin-success);
}

.admin-user__panel-token-value--warning {
  color: var(--admin-warning);
}

.admin-user__panel-token-value--danger {
  color: var(--admin-error);
}

/* Panel usage bar (lg size for panel) */
.admin-user__panel-usage-bar-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.admin-user__panel-usage-bar {
  flex: 1 1;
  height: 8px;
  background: var(--admin-bg);
  border-radius: 4px;
  overflow: hidden;
}

.admin-user__panel-usage-bar-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.6s ease;
}

.admin-user__panel-usage-bar-fill--normal {
  background: var(--admin-success);
}

.admin-user__panel-usage-bar-fill--warning {
  background: var(--admin-warning);
}

.admin-user__panel-usage-bar-fill--danger {
  background: var(--admin-error);
}

.admin-user__panel-usage-pct {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.admin-user__panel-usage-pct--normal { color: var(--admin-success); }
.admin-user__panel-usage-pct--warning { color: var(--admin-warning); }
.admin-user__panel-usage-pct--danger { color: var(--admin-error); }

/* Grant button in panel */
.admin-user__panel-grant-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  justify-content: center;
}

/* History wrap scroll */
.admin-user__panel-history-wrap {
  overflow-x: auto;
  max-height: 280px;
  overflow-y: auto;
}

/* History loading */
.admin-user__panel-history-loading {
  text-align: center;
  padding: 24px;
  font-size: 13px;
  color: var(--admin-text-muted);
}

/* Transaction amount */
.admin-user__tx-amount {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  font-size: 12px;
}

.admin-user__tx-amount--positive {
  color: var(--admin-success);
}

.admin-user__tx-amount--negative {
  color: var(--admin-error);
}
`, "",{"version":3,"sources":["webpack://./src/css/adminUserManagement.css"],"names":[],"mappings":"AAAA,yEAAyE;;AAEzE,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,gCAAgC;EAChC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;AAChC;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,gCAAgC;EAChC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,4CAA4C;EAC5C,8BAA8B;AAChC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA,UAAU;AACV;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;EAChC,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,aAAa;AACb;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qFAAqF;EACrF,2BAA2B;AAC7B;;AAEA;EACE,qFAAqF;EACrF,wBAAwB;AAC1B;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qFAAqF;EACrF,2BAA2B;AAC7B;;AAEA;EACE,qFAAqF;EACrF,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,sCAAsC;EACtC,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,sCAAsC;EACtC,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,+BAA+B;EAC/B,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,2BAA2B;EAC3B,qCAAqC;EACrC,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,+BAA+B;EAC/B,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,iBAAiB;EACjB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,+BAA+B;EAC/B,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA,yBAAyB;AACzB;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,MAAM;EACN,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,gDAAgD;EAChD,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,4CAA4C;EAC5C,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,2BAA2B;EAC3B,qCAAqC;EACrC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,kCAAkC;EAClC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,kDAAkD;EAClD,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,2BAA2B;EAC3B,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,2BAA2B;EAC3B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA,mDAAmD;AACnD;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,qCAAqC;AACrC;EACE,qFAAqF;EACrF,2BAA2B;AAC7B;;AAEA;EACE,qFAAqF;EACrF,wBAAwB;AAC1B;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,uCAAuC,2BAA2B,EAAE;AACpE,wCAAwC,2BAA2B,EAAE;AACrE,uCAAuC,yBAAyB,EAAE;;AAElE,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* ===== Admin User Management Styles — Dark Data-Dashboard Theme ===== */\n\n/* Stats Grid */\n.admin-user__stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.admin-user__stat-card {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-lg);\n  padding: 20px;\n  transition: all 0.2s;\n}\n\n.admin-user__stat-card:hover {\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.35);\n  transform: translateY(-2px);\n}\n\n.admin-user__stat-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.admin-user__stat-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.admin-user__stat-icon--total {\n  background: rgba(167, 139, 250, 0.1);\n  color: #a78bfa;\n}\n\n.admin-user__stat-icon--member {\n  background: var(--admin-info-bg);\n  color: var(--admin-info);\n}\n\n.admin-user__stat-icon--partner {\n  background: rgba(167, 139, 250, 0.15);\n  color: #c4b5fd;\n}\n\n.admin-user__stat-icon--manager {\n  background: var(--admin-warning-bg);\n  color: var(--admin-warning);\n}\n\n.admin-user__stat-icon--admin {\n  background: var(--admin-warning-bg);\n  color: var(--admin-warning);\n}\n\n.admin-user__stat-icon--org {\n  background: var(--admin-success-bg);\n  color: var(--admin-success);\n}\n\n.admin-user__stat-label {\n  font-size: 12px;\n  color: var(--admin-text-muted);\n  margin-bottom: 8px;\n}\n\n.admin-user__stat-value {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--admin-text-bright);\n}\n\n/* Tabs */\n.admin-user__tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n}\n\n.admin-user__tab {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 18px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--admin-text-secondary);\n  background: var(--admin-surface);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.admin-user__tab:hover {\n  background: var(--admin-surface-hover);\n  border-color: var(--admin-text-dim);\n  color: var(--admin-text-primary);\n}\n\n.admin-user__tab--active {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-bright);\n  border-color: var(--admin-text-dim);\n}\n\n.admin-user__tab-badge {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-secondary);\n  padding: 2px 10px;\n  border-radius: var(--radius-full);\n  font-size: 12px;\n  font-weight: 600;\n  min-width: 24px;\n  text-align: center;\n}\n\n.admin-user__tab--active .admin-user__tab-badge {\n  background: rgba(167, 139, 250, 0.15);\n  color: #a78bfa;\n}\n\n/* Table Container */\n.admin-user__table-container {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n\n.admin-user__table-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n  border-bottom: 1px solid var(--admin-border);\n  background: var(--admin-surface);\n  gap: 16px;\n}\n\n.admin-user__table-title {\n  font-size: 15px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--admin-text-bright);\n  white-space: nowrap;\n}\n\n.admin-user__table-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.admin-user__search-input {\n  width: 260px;\n  padding: 8px 14px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  font-size: 13px;\n  background: var(--admin-bg);\n  color: var(--admin-text-primary);\n  transition: all 0.2s;\n}\n\n.admin-user__search-input:focus {\n  outline: none;\n  border-color: #a78bfa;\n  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);\n}\n\n.admin-user__search-input::placeholder {\n  color: var(--admin-text-muted);\n}\n\n/* 동의 목록 JSON 다운로드 버튼 */\n.admin-user__download-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  background: var(--admin-surface);\n  color: var(--admin-text-secondary);\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.admin-user__download-btn:hover {\n  border-color: var(--admin-accent);\n  color: var(--admin-accent-hover);\n  background: var(--admin-accent-bg);\n}\n\n.admin-user__download-btn .admin-icon {\n  width: 15px;\n  height: 15px;\n}\n\n/* Bulk Actions Bar */\n.admin-user__bulk-bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 24px;\n  background: var(--admin-surface);\n  border-bottom: 1px solid var(--admin-border);\n  animation: bulkBarIn 0.2s ease;\n}\n\n@keyframes bulkBarIn {\n  from { opacity: 0; transform: translateY(-4px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.admin-user__bulk-count {\n  font-size: 13px;\n  font-weight: 600;\n  color: #a78bfa;\n  white-space: nowrap;\n}\n\n.admin-user__bulk-select {\n  padding: 6px 12px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  font-size: 12px;\n  background: var(--admin-bg);\n  color: var(--admin-text-primary);\n  cursor: pointer;\n}\n\n.admin-user__bulk-select:focus {\n  outline: none;\n  border-color: #a78bfa;\n}\n\n.admin-user__bulk-btn {\n  padding: 6px 14px;\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  background: #a78bfa;\n  color: var(--admin-bg);\n}\n\n.admin-user__bulk-btn:hover {\n  background: #8b5cf6;\n}\n\n.admin-user__bulk-btn--danger {\n  background: #ef4444;\n  color: #fff;\n}\n\n.admin-user__bulk-btn--danger:hover {\n  background: #dc2626;\n}\n\n.admin-user__bulk-cancel {\n  padding: 6px 14px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  background: var(--admin-bg);\n  color: var(--admin-text-secondary);\n  transition: all 0.2s;\n}\n\n.admin-user__bulk-cancel:hover {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-primary);\n}\n\n/* Table */\n.admin-user__table-wrap {\n  overflow-x: auto;\n}\n\n.admin-user__table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.admin-user__table th {\n  text-align: left;\n  padding: 10px 16px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--admin-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  background: var(--admin-surface);\n  border-bottom: 1px solid var(--admin-border);\n  white-space: nowrap;\n}\n\n.admin-user__table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--admin-border-light);\n  vertical-align: middle;\n  color: var(--admin-text-primary);\n}\n\n.admin-user__table tbody tr {\n  transition: background 0.15s;\n}\n\n.admin-user__table tbody tr:hover {\n  background: var(--admin-surface-hover);\n}\n\n.admin-user__table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.admin-user__table tbody tr.admin-user__row--selected {\n  background: rgba(167, 139, 250, 0.08);\n}\n\n/* Checkbox */\n.admin-user__checkbox {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  accent-color: #a78bfa;\n}\n\n/* User Cell */\n.admin-user__cell-user {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.admin-user__avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: var(--radius-full);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 600;\n  color: white;\n  flex-shrink: 0;\n}\n\n.admin-user__avatar--admin {\n  background: linear-gradient(135deg, rgba(251, 146, 60, 0.2), rgba(251, 146, 60, 0.1));\n  color: var(--admin-warning);\n}\n\n.admin-user__avatar--member {\n  background: linear-gradient(135deg, rgba(34, 211, 238, 0.2), rgba(34, 211, 238, 0.1));\n  color: var(--admin-info);\n}\n\n.admin-user__avatar--partner {\n  background: linear-gradient(135deg, #a78bfa, #7c3aed);\n  color: white;\n}\n\n.admin-user__avatar--manager {\n  background: linear-gradient(135deg, rgba(251, 146, 60, 0.2), rgba(251, 146, 60, 0.1));\n  color: var(--admin-warning);\n}\n\n.admin-user__avatar--organization {\n  background: linear-gradient(135deg, rgba(74, 222, 128, 0.2), rgba(74, 222, 128, 0.1));\n  color: var(--admin-success);\n}\n\n.admin-user__name {\n  font-weight: 600;\n  color: var(--admin-text-bright);\n  font-size: 13px;\n}\n\n.admin-user__email {\n  font-size: 12px;\n  color: var(--admin-text-muted);\n  margin-top: 2px;\n}\n\n/* Role Badge */\n.admin-user__role-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border-radius: var(--radius-full);\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.admin-user__role-badge--admin {\n  background: var(--admin-warning-bg);\n  color: var(--admin-warning);\n}\n\n.admin-user__role-badge--member {\n  background: var(--admin-info-bg);\n  color: var(--admin-info);\n}\n\n.admin-user__role-badge--partner {\n  background: rgba(167, 139, 250, 0.12);\n  color: #a78bfa;\n}\n\n.admin-user__role-badge--manager {\n  background: var(--admin-warning-bg);\n  color: var(--admin-warning);\n}\n\n.admin-user__role-badge--organization {\n  background: var(--admin-success-bg);\n  color: var(--admin-success);\n}\n\n/* Status */\n.admin-user__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.admin-user__status-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n}\n\n.admin-user__status--active .admin-user__status-dot {\n  background: var(--admin-success);\n  box-shadow: 0 0 0 3px var(--admin-success-bg);\n}\n\n.admin-user__status--active {\n  color: var(--admin-success);\n}\n\n.admin-user__status--inactive .admin-user__status-dot {\n  background: var(--admin-text-dim);\n}\n\n.admin-user__status--inactive {\n  color: var(--admin-text-muted);\n}\n\n/* 수신동의 뱃지 (테이블) */\n.admin-user__consent {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.admin-user__consent-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 2px 7px 2px 5px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.4;\n  white-space: nowrap;\n}\n\n.admin-user__consent-badge svg {\n  width: 11px;\n  height: 11px;\n  flex-shrink: 0;\n}\n\n.admin-user__consent-badge--on {\n  background: var(--admin-success-bg);\n  color: var(--admin-success);\n}\n\n.admin-user__consent-badge--off {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-muted);\n}\n\n.admin-user__consent-old {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 999px;\n  border: 1px dashed var(--admin-border);\n  background: transparent;\n  color: var(--admin-text-muted);\n  font-size: 11px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n/* 수신동의 현황 (사이드 패널) */\n.admin-user__panel-consent-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.admin-user__panel-consent-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.admin-user__panel-consent-label {\n  font-size: 12px;\n  color: var(--admin-text-secondary);\n}\n\n.admin-user__panel-consent-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.admin-user__panel-consent-status--on {\n  color: var(--admin-success);\n}\n\n.admin-user__panel-consent-status--off {\n  color: var(--admin-text-muted);\n}\n\n.admin-user__panel-consent-at {\n  font-size: 11px;\n  font-weight: 400;\n  color: var(--admin-text-muted);\n}\n\n.admin-user__panel-consent-empty {\n  padding: 10px 12px;\n  border-radius: var(--admin-radius-sm);\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-muted);\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n/* Action Buttons */\n.admin-user__action-group {\n  display: flex;\n  gap: 6px;\n}\n\n.admin-user__action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  background: transparent;\n  color: var(--admin-text-secondary);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.admin-user__action-btn:hover {\n  background: var(--admin-surface-hover);\n  border-color: var(--admin-text-dim);\n  color: var(--admin-text-primary);\n}\n\n.admin-user__action-btn--danger:hover {\n  background: var(--admin-error-bg);\n  border-color: var(--admin-error);\n  color: var(--admin-error);\n}\n\n/* Modal */\n.admin-user__modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.7);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(4px);\n}\n\n.admin-user__modal {\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-xl);\n  width: 100%;\n  max-width: 480px;\n  max-height: 90vh;\n  overflow: hidden;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n  animation: modalIn 0.2s ease;\n}\n\n.admin-user__modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--admin-border);\n}\n\n.admin-user__modal-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--admin-text-bright);\n}\n\n.admin-user__modal-close {\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-md);\n  background: var(--admin-bg);\n  border: 1px solid var(--admin-border);\n  font-size: 20px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--admin-text-secondary);\n  transition: all 0.2s;\n}\n\n.admin-user__modal-close:hover {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-bright);\n}\n\n.admin-user__modal-body {\n  padding: 24px;\n}\n\n.admin-user__modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid var(--admin-border);\n  background: var(--admin-bg);\n}\n\n.admin-user__modal-user {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  background: var(--admin-bg);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  margin-bottom: 20px;\n}\n\n.admin-user__modal-user-info {\n  flex: 1;\n}\n\n.admin-user__modal-user-name {\n  font-weight: 600;\n  font-size: 14px;\n  color: var(--admin-text-bright);\n}\n\n.admin-user__modal-user-email {\n  font-size: 12px;\n  color: var(--admin-text-muted);\n  margin-top: 2px;\n}\n\n.admin-user__form-group {\n  margin-bottom: 20px;\n}\n\n.admin-user__form-label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: var(--admin-text-primary);\n}\n\n.admin-user__form-select {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  font-size: 14px;\n  background: var(--admin-bg);\n  color: var(--admin-text-primary);\n  transition: all 0.2s;\n  cursor: pointer;\n}\n\n.admin-user__form-select:focus {\n  outline: none;\n  border-color: #a78bfa;\n  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);\n}\n\n.admin-user__role-change-preview {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: rgba(167, 139, 250, 0.08);\n  border: 1px solid rgba(167, 139, 250, 0.2);\n  border-radius: var(--radius-md);\n  font-size: 13px;\n  color: var(--admin-text-primary);\n}\n\n.admin-user__role-arrow {\n  color: var(--admin-text-muted);\n  font-size: 16px;\n}\n\n/* Empty State */\n.admin-user__empty-state {\n  text-align: center;\n  padding: 60px 20px;\n}\n\n.admin-user__empty-icon {\n  width: 64px;\n  height: 64px;\n  margin: 0 auto 16px;\n  color: var(--admin-text-dim);\n  stroke-width: 1.5;\n  stroke: currentColor;\n  fill: none;\n}\n\n.admin-user__empty-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--admin-text-secondary);\n  margin-bottom: 8px;\n}\n\n.admin-user__empty-desc {\n  font-size: 13px;\n  color: var(--admin-text-muted);\n}\n\n/* Pagination */\n.admin-user__pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 24px;\n  border-top: 1px solid var(--admin-border);\n  background: var(--admin-surface);\n}\n\n.admin-user__pagination-info {\n  font-size: 12px;\n  color: var(--admin-text-muted);\n}\n\n.admin-user__pagination-buttons {\n  display: flex;\n  gap: 4px;\n}\n\n.admin-user__pagination-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 32px;\n  height: 32px;\n  padding: 0 8px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  background: transparent;\n  color: var(--admin-text-secondary);\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.admin-user__pagination-btn:hover {\n  background: var(--admin-surface-hover);\n  border-color: var(--admin-text-dim);\n  color: var(--admin-text-primary);\n}\n\n.admin-user__pagination-btn--active {\n  background: var(--admin-accent);\n  border-color: var(--admin-accent);\n  color: #fff;\n}\n\n.admin-user__pagination-btn--active:hover {\n  background: var(--admin-accent-hover);\n  border-color: var(--admin-accent-hover);\n  color: #fff;\n}\n\n.admin-user__pagination-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.admin-user__pagination-ellipsis {\n  display: inline-flex;\n  align-items: flex-end;\n  justify-content: center;\n  min-width: 24px;\n  height: 32px;\n  padding-bottom: 6px;\n  color: var(--admin-text-muted);\n  font-size: 12px;\n  user-select: none;\n}\n\n/* Date text */\n.admin-user__date {\n  font-size: 12px;\n  color: var(--admin-text-secondary);\n}\n\n/* Enrollment stat icon */\n.admin-user__stat-icon--enrollment {\n  background: var(--admin-success-bg);\n  color: var(--admin-success);\n}\n\n/* Avatar — image and initial variants */\n.admin-users__avatar {\n  width: 30px;\n  height: 30px;\n  border-radius: var(--radius-full);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 600;\n  color: white;\n  flex-shrink: 0;\n  object-fit: cover;\n}\n\n.admin-users__avatar--initial {\n  /* color is provided by admin-user__avatar--{role} modifier */\n  user-select: none;\n}\n\n/* Department cell */\n.admin-user__department {\n  font-size: 12px;\n  color: var(--admin-text-secondary);\n}\n\n/* Activity (enrollment / session) cell */\n.admin-user__activity {\n  font-size: 12px;\n  color: var(--admin-text-secondary);\n  white-space: nowrap;\n}\n\n/* ===== Layout: Table + Side Panel ===== */\n.admin-user__layout {\n  display: flex;\n  gap: 0;\n  transition: all 0.3s ease;\n}\n\n.admin-user__layout .admin-user__table-container {\n  flex: 1;\n  min-width: 0;\n  transition: all 0.3s ease;\n}\n\n/* ===== Token Number in Table ===== */\n.admin-user__token-number {\n  font-weight: 600;\n  font-size: 13px;\n  font-variant-numeric: tabular-nums;\n}\n\n.admin-user__token-number--normal {\n  color: var(--admin-success);\n}\n\n.admin-user__token-number--warning {\n  color: var(--admin-warning);\n}\n\n.admin-user__token-number--danger {\n  color: var(--admin-error);\n}\n\n/* ===== Usage Bar in Table ===== */\n.admin-user__usage {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 100px;\n}\n\n.admin-user__usage-bar {\n  flex: 1;\n  height: 6px;\n  background: var(--admin-bg);\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.admin-user__usage-bar--lg {\n  height: 8px;\n}\n\n.admin-user__usage-bar-fill {\n  height: 100%;\n  border-radius: 3px;\n  transition: width 0.6s ease;\n}\n\n.admin-user__usage-bar-fill--normal {\n  background: var(--admin-success);\n}\n\n.admin-user__usage-bar-fill--warning {\n  background: var(--admin-warning);\n}\n\n.admin-user__usage-bar-fill--danger {\n  background: var(--admin-error);\n}\n\n.admin-user__usage-pct {\n  font-size: 12px;\n  font-weight: 600;\n  min-width: 36px;\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n.admin-user__usage-pct--normal {\n  color: var(--admin-success);\n}\n\n.admin-user__usage-pct--warning {\n  color: var(--admin-warning);\n}\n\n.admin-user__usage-pct--danger {\n  color: var(--admin-error);\n}\n\n/* Row active state when panel is open */\n.admin-user__row--panel-active {\n  background: rgba(167, 139, 250, 0.12) !important;\n  border-left: 3px solid #a78bfa;\n}\n\n/* ===== Side Panel ===== */\n.admin-user__panel {\n  width: 400px;\n  min-width: 400px;\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-lg);\n  display: flex;\n  flex-direction: column;\n  max-height: calc(100vh - 180px);\n  overflow: hidden;\n  animation: panelSlideIn 0.3s ease;\n  margin-left: 16px;\n}\n\n@keyframes panelSlideIn {\n  from {\n    opacity: 0;\n    transform: translateX(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.admin-user__panel-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 20px;\n  border-bottom: 1px solid var(--admin-border);\n  gap: 12px;\n}\n\n.admin-user__panel-user {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  min-width: 0;\n}\n\n.admin-user__panel-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: var(--radius-full);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  font-weight: 600;\n  color: white;\n  flex-shrink: 0;\n  object-fit: cover;\n}\n\n.admin-user__panel-avatar--initial {\n  user-select: none;\n}\n\n.admin-user__panel-user-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.admin-user__panel-user-name {\n  font-weight: 600;\n  font-size: 15px;\n  color: var(--admin-text-bright);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.admin-user__panel-user-email {\n  font-size: 12px;\n  color: var(--admin-text-muted);\n  margin-top: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.admin-user__panel-close {\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-md);\n  background: var(--admin-bg);\n  border: 1px solid var(--admin-border);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--admin-text-secondary);\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.admin-user__panel-close:hover {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-bright);\n}\n\n.admin-user__panel-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0;\n}\n\n/* Panel Sections */\n.admin-user__panel-section {\n  padding: 20px;\n  border-bottom: 1px solid var(--admin-border);\n}\n\n.admin-user__panel-section:last-child {\n  border-bottom: none;\n}\n\n.admin-user__panel-section-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--admin-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin: 0 0 12px 0;\n}\n\n/* Info Grid */\n.admin-user__panel-info-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.admin-user__panel-info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.admin-user__panel-info-label {\n  font-size: 11px;\n  color: var(--admin-text-muted);\n  font-weight: 500;\n}\n\n.admin-user__panel-info-value {\n  font-size: 13px;\n  color: var(--admin-text-primary);\n  font-weight: 500;\n}\n\n/* Panel Actions */\n.admin-user__panel-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n/* Token Grid in Panel */\n.admin-user__panel-token-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.admin-user__panel-token-item {\n  padding: 10px;\n  background: var(--admin-bg);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  text-align: center;\n}\n\n.admin-user__panel-token-label {\n  display: block;\n  font-size: 10px;\n  font-weight: 600;\n  color: var(--admin-text-muted);\n  margin-bottom: 4px;\n}\n\n.admin-user__panel-token-value {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--admin-text-bright);\n  font-variant-numeric: tabular-nums;\n}\n\n.admin-user__panel-token-empty {\n  text-align: center;\n  padding: 20px;\n  font-size: 13px;\n  color: var(--admin-text-muted);\n}\n\n.admin-user__panel-usage {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n/* History in Panel */\n.admin-user__panel-history {\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.admin-user__panel-history-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.admin-user__panel-history-table th {\n  text-align: left;\n  font-size: 10px;\n  font-weight: 600;\n  color: var(--admin-text-muted);\n  text-transform: uppercase;\n  padding: 6px 8px;\n  border-bottom: 1px solid var(--admin-border);\n}\n\n.admin-user__panel-history-table td {\n  padding: 8px;\n  border-bottom: 1px solid var(--admin-border-light);\n  vertical-align: middle;\n  color: var(--admin-text-primary);\n}\n\n.admin-user__panel-history-table tr:last-child td {\n  border-bottom: none;\n}\n\n.admin-user__panel-history-date {\n  color: var(--admin-text-muted);\n  font-size: 11px;\n  white-space: nowrap;\n}\n\n.admin-user__panel-history-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 12px 0 0;\n  margin-top: 8px;\n  border-top: 1px solid var(--admin-border);\n}\n\n.admin-user__panel-history-page {\n  font-size: 12px;\n  color: var(--admin-text-secondary);\n}\n\n.admin-user__panel-history-empty {\n  text-align: center;\n  padding: 24px;\n  font-size: 13px;\n  color: var(--admin-text-muted);\n}\n\n/* Transaction Badge */\n.admin-user__tx-badge {\n  display: inline-block;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.admin-user__tx-badge--usage {\n  background: var(--admin-info-bg);\n  color: var(--admin-info);\n}\n\n.admin-user__tx-badge--admin_grant {\n  background: var(--admin-success-bg);\n  color: var(--admin-success);\n}\n\n.admin-user__tx-badge--admin_deduct {\n  background: var(--admin-warning-bg);\n  color: var(--admin-warning);\n}\n\n.admin-user__tx-badge--purchase {\n  background: rgba(167, 139, 250, 0.12);\n  color: #a78bfa;\n}\n\n.admin-user__tx-badge--refund {\n  background: var(--admin-error-bg);\n  color: var(--admin-error);\n}\n\n.admin-user__tx-positive {\n  color: var(--admin-success);\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n.admin-user__tx-negative {\n  color: var(--admin-error);\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n.admin-user__tx-balance {\n  font-weight: 500;\n  color: var(--admin-text-secondary);\n  font-variant-numeric: tabular-nums;\n}\n\n/* Grant Modal — Balance Info */\n.admin-user__grant-balance {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.admin-user__grant-balance-item {\n  padding: 12px 16px;\n  background: var(--admin-bg);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--admin-border);\n}\n\n.admin-user__grant-balance-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--admin-text-muted);\n  margin-bottom: 4px;\n}\n\n.admin-user__grant-balance-value {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--admin-text-bright);\n  font-variant-numeric: tabular-nums;\n}\n\n/* Form Input (for grant modal) */\n.admin-user__form-input {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  font-size: 14px;\n  background: var(--admin-bg);\n  color: var(--admin-text-bright);\n  transition: all 0.2s;\n}\n\n.admin-user__form-input:focus {\n  outline: none;\n  border-color: #a78bfa;\n  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);\n}\n\n.admin-user__form-input::placeholder {\n  color: var(--admin-text-muted);\n}\n\n/* Preset Buttons */\n.admin-user__form-presets {\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n  flex-wrap: wrap;\n}\n\n.admin-user__preset-btn {\n  padding: 4px 12px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-full);\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--admin-text-secondary);\n  background: var(--admin-bg);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.admin-user__preset-btn:hover {\n  background: rgba(167, 139, 250, 0.1);\n  border-color: #a78bfa;\n  color: #a78bfa;\n}\n\n/* Small button variants */\n.admin-btn--sm {\n  padding: 6px 14px;\n  font-size: 12px;\n}\n\n.admin-btn--danger {\n  background: transparent;\n  border: 1px solid var(--admin-error);\n  color: var(--admin-error);\n}\n\n.admin-btn--danger:hover {\n  background: var(--admin-error-bg);\n}\n\n/* ===== Stat icon variants for token stats ===== */\n.admin-user__stat-icon--issued {\n  background: rgba(167, 139, 250, 0.1);\n  color: #a78bfa;\n}\n\n.admin-user__stat-icon--used {\n  background: var(--admin-error-bg);\n  color: var(--admin-error);\n}\n\n.admin-user__stat-icon--remaining {\n  background: var(--admin-success-bg);\n  color: var(--admin-success);\n}\n\n/* Roles inline stat value */\n.admin-user__stat-value--roles {\n  font-size: 13px;\n  font-weight: 600;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n/* Token remaining in table */\n.admin-user__token-remaining {\n  font-weight: 600;\n  font-size: 13px;\n  font-variant-numeric: tabular-nums;\n}\n\n.admin-user__token-remaining--normal {\n  color: var(--admin-success);\n}\n\n.admin-user__token-remaining--warning {\n  color: var(--admin-warning);\n}\n\n.admin-user__token-remaining--danger {\n  color: var(--admin-error);\n}\n\n/* Panel chevron button */\n.admin-user__panel-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-md);\n  background: transparent;\n  color: var(--admin-text-muted);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.admin-user__panel-btn:hover {\n  background: var(--admin-surface-hover);\n  color: var(--admin-text-primary);\n}\n\n.admin-user__panel-btn--active {\n  background: rgba(167, 139, 250, 0.12);\n  border-color: #a78bfa;\n  color: #a78bfa;\n}\n\n/* Side panel — actual rendered element class */\n.admin-user__side-panel {\n  width: 400px;\n  min-width: 400px;\n  background: var(--admin-surface);\n  border: 1px solid var(--admin-border);\n  border-radius: var(--radius-lg);\n  display: flex;\n  flex-direction: column;\n  max-height: calc(100vh - 180px);\n  overflow: hidden;\n  animation: panelSlideIn 0.3s ease;\n  margin-left: 16px;\n}\n\n.admin-user__side-panel .admin-user__panel-body {\n  flex: 1;\n  overflow-y: auto;\n}\n\n/* Panel header user info block */\n.admin-user__panel-user-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  min-width: 0;\n}\n\n.admin-user__panel-user-meta {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n/* Panel avatar role color variants */\n.admin-user__panel-avatar--admin {\n  background: linear-gradient(135deg, rgba(251, 146, 60, 0.2), rgba(251, 146, 60, 0.1));\n  color: var(--admin-warning);\n}\n\n.admin-user__panel-avatar--member {\n  background: linear-gradient(135deg, rgba(34, 211, 238, 0.2), rgba(34, 211, 238, 0.1));\n  color: var(--admin-info);\n}\n\n.admin-user__panel-avatar--partner {\n  background: linear-gradient(135deg, #a78bfa, #7c3aed);\n  color: white;\n}\n\n/* Panel token value color variants */\n.admin-user__panel-token-value--used {\n  color: var(--admin-error);\n}\n\n.admin-user__panel-token-value--balance {\n  color: var(--admin-info);\n}\n\n.admin-user__panel-token-value--normal {\n  color: var(--admin-success);\n}\n\n.admin-user__panel-token-value--warning {\n  color: var(--admin-warning);\n}\n\n.admin-user__panel-token-value--danger {\n  color: var(--admin-error);\n}\n\n/* Panel usage bar (lg size for panel) */\n.admin-user__panel-usage-bar-wrap {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.admin-user__panel-usage-bar {\n  flex: 1;\n  height: 8px;\n  background: var(--admin-bg);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.admin-user__panel-usage-bar-fill {\n  height: 100%;\n  border-radius: 4px;\n  transition: width 0.6s ease;\n}\n\n.admin-user__panel-usage-bar-fill--normal {\n  background: var(--admin-success);\n}\n\n.admin-user__panel-usage-bar-fill--warning {\n  background: var(--admin-warning);\n}\n\n.admin-user__panel-usage-bar-fill--danger {\n  background: var(--admin-error);\n}\n\n.admin-user__panel-usage-pct {\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.admin-user__panel-usage-pct--normal { color: var(--admin-success); }\n.admin-user__panel-usage-pct--warning { color: var(--admin-warning); }\n.admin-user__panel-usage-pct--danger { color: var(--admin-error); }\n\n/* Grant button in panel */\n.admin-user__panel-grant-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  justify-content: center;\n}\n\n/* History wrap scroll */\n.admin-user__panel-history-wrap {\n  overflow-x: auto;\n  max-height: 280px;\n  overflow-y: auto;\n}\n\n/* History loading */\n.admin-user__panel-history-loading {\n  text-align: center;\n  padding: 24px;\n  font-size: 13px;\n  color: var(--admin-text-muted);\n}\n\n/* Transaction amount */\n.admin-user__tx-amount {\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  font-size: 12px;\n}\n\n.admin-user__tx-amount--positive {\n  color: var(--admin-success);\n}\n\n.admin-user__tx-amount--negative {\n  color: var(--admin-error);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
